<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <ToTool/>
</template>

<script>
import ToTool from './components/ToTool.vue'

export default {
  name: 'App',
  components: {
    ToTool
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  margin-bottom: 60px;
}
</style>
